<div class="chatbot-window" id="chatbot-window">
  <div class="content">
    <div class="chat-header">
      <div class="profile">
        <nz-avatar nzIcon="user" nzAlt="Avatar" class="bot-avatar" [nzSize]="45" [nzSrc]="qbotAvatarUrl"></nz-avatar>
        <div class="description">
          <div class="small">Chat with</div>
          <div class="main">QBot</div>
        </div>
      </div>
      <div class="header-setting">
        <div class="custom-button" (click)="toggleSpeaker()">
          <span nz-icon [nzIconfont]="isMute?'icon-mute':'icon-speaker'"></span>
        </div>
        <div class="custom-button" (click)="toggleChatbot()">
          <span nz-icon nzType="close" nzTheme="outline"></span>
        </div>
      </div>
    </div>

    <div class="chat-window" #chatListContainer>
      @if (messages.length > 0) {
      @for (chatContext of messages; track $index) {
      <div class="chat-bubble" [ngClass]="{ right: !chatContext.isMachine,
                        left: chatContext.isMachine }">
        <div class="bot" *ngIf="chatContext.isMachine">QBot</div>
        <div class="message-wrapper">
          <div *ngIf="chatContext.isMachine" class="bot-message-body">
            <img id="avatar" [src]="qbotAvatarUrl" />
          </div>
          <div id="message-body">
            <div class="message" [innerHTML]="chatContext?.text" ng-trim="false"></div>
          </div>
        </div>
      </div>
      }
      }

      @if (availableOptions.length > 0) {
      <div class="chat-footer">
        <div class="menu-option" #optionMenu>
          @for (option of availableOptions; track option; let i = $index) {
          <button type="button" class="custom-button" [name]="'btn-'+i" (click)="send(option)">{{
            option.label
            }}
          </button>
          }
        </div>
      </div>
      }


      @if (isWaiting) {
      <div class="chat-bubble left">
        <div class="bot">QBot</div>
        <div class="message-wrapper">
          <div><img id="avatar" [src]="qbotAvatarUrl" /></div>
          <div id="message-body" class="typing">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<div [hidden]="hideIcon()" class="alain-default__nav-item custom-nav-item" nz-dropdown nzTrigger="click" nzPlacement="bottomCenter"
  [nzDropdownMenu]="chatbotMenu">
  <img class="avatar-icon" src="https://cdn.qne.cloud/qca/assets/img/n3/Qbot-AI-Assistant.webp" />
</div>

<nz-dropdown-menu #chatbotMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="openAiAssistant()">
      Qbot AI Support
      @if (showWhatsappSupport) {
        <span class="support-channel-note support-channel-note--discontinued">(Discontinued Soon)</span>
      }
    </li>
    <li nz-menu-item (click)="toggleChatbot()" [acl]="{ ability: ['chatbot.view', 'm2.1024'], mode: 'allOf' }">Qbot
      Chatbot
    </li>
    @if (showWhatsappSupport) {
    <li nz-menu-item (click)="navigateToWhatsappSupport()"
      (keydown.enter)="navigateToWhatsappSupport()"
      (keydown.space)="$event.preventDefault(); navigateToWhatsappSupport()">
      WhatsApp AI Support
      <span class="support-channel-note support-channel-note--new">(New Support Channel)</span>
    </li>
    }
  </ul>
</nz-dropdown-menu>
